import React from "react";
import { useParams } from "react-router-dom";
import RoleEdit from "../../components/roleEdit/RoleEdit";
import TeamMenu from "../../components/teamMenu/TeamMenu";

const RoleEditPage = () => {
  let { roleId } = useParams();
  return (
    <>
      <TeamMenu>
        <RoleEdit roleId={roleId} />
      </TeamMenu>
    </>
  );
};

export default RoleEditPage;
